<template>
  <header class="global-header">
    <div class="global-header__inner">
      <h1 class="logo">
        <a href="/">
          <img src="/assets/sf/image/logo_sauna.svg" alt="SAUNA FINANCE" />
        </a>
      </h1>

      <div class="global-header__actions">
        <button
          v-if="$store.state.isLogin"
          @click="openModal('account-wallet-modal')"
          class="account-wallet"
        >
          <span class="eth"
            >{{ toFormattedToken($store.state.account.balance) }}
            {{ $store.state.account.symbol }}
          </span>
          <span class="id">{{ $store.state.account.address }}</span>
        </button>
        <input-button
          v-else
          @click="openModal('modal-connect-wallet')"
          :disabled="$store.state.modal.isShow"
          :size="'small'"
          >connect<span class="pc"> to wallet</span></input-button
        >

        <span class="toggle-theme">
          <button
            :class="[
              'theme-button',
              '--light',
              { 'is-active': $store.state.theme == 'light' },
            ]"
            @click="changeTheme('light')"
          >
            change light mode<i class="emoji">🌞</i>
          </button>
          <button
            :class="[
              'theme-button',
              '--dark',
              { 'is-active': $store.state.theme == 'dark' },
            ]"
            @click="changeTheme('dark')"
          >
            change dark mode<i class="emoji">🌚</i>
          </button>
        </span>
      </div>
    </div>
  </header>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import numFormat from "number-format.js";

export default {
  name: "GlobalHeader",
  components: {
    InputButton,
  },
  computed: {
    web3() {
      return this.$store.state.web3;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat(
        "#,##0.00000",
        this.web3.instance.utils.fromWei(num, "ether")
      );
    },
    changeTheme(theme) {
      this.$store.dispatch("changeTheme", theme);
    },
    openModal(target) {
      this.$store.dispatch("openModal", target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.pc {
  @include media(sp) {
    display: none;
  }
}
.global-header {
  background: var(--color_bg_parts);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    width: 1110px;
  }
  @include media(pc) {
    height: 100px;
    padding: 0 80px;

    .logo {
      height: 36px;
    }
  }
  @include media(sp) {
    height: 72px;
    padding: 0 24px;

    .logo {
      height: 24px;
      padding-right: 12px;
    }
  }
  .logo {
    white-space: nowrap;
  }
  &__actions {
    display: flex;
    align-items: center;
  }
}
.account-wallet {
  font-weight: 700;
  color: var(--color_font_parts);
  display: flex;
  align-items: center;
  background: var(--color_bg);

  @include media(pc) {
    height: 42px;
    border-radius: 21px;
    padding: 7px;
    font-size: 1.2rem;

    .eth {
      margin-left: 24px;
    }
    .id {
      max-width: 192px;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      padding: 0 16px;
      margin-left: 16px;
    }
  }
  @include media(sp) {
    height: 24px;
    border-radius: 12px;
    padding: 4px;
    font-size: 1rem;

    .eth {
      display: none;
    }
    .id {
      max-width: 96px;
      height: 16px;
      line-height: 16px;
      border-radius: 8px;
      padding: 0 8px;
    }
  }
  .id {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    background: var(--color_bg_parts);
  }
}
.toggle-theme {
  display: grid;
  text-align: center;
  align-items: center;
  grid-gap: 1px;

  @include media(pc) {
    margin-left: 24px;
    grid-template-columns: 4rem 18px 4rem;

    &::before {
      content: "";
      background: $gray1;
      display: block;
      width: 1px;
      height: 32px;
      transform: rotate(25deg);
      transform-origin: bottom;
      grid-row: 1;
      grid-column: 2;
    }
  }
  @include media(sp) {
    margin-left: 8px;
  }
}
.theme-button {
  font-size: 0;

  @include media(pc) {
    .emoji {
      font-size: 28px;
    }
  }
  @include media(sp) {
    .emoji {
      font-size: 2rem;
    }
    &.is-active {
      display: none;
    }
  }
  .emoji {
    font-style: normal;
  }
  &--light {
    grid-row: 1;
    grid-column: 1;
  }
  &--dark {
    grid-row: 1;
    grid-column: 3;
  }
}
</style>